module.exports = __webpack_public_path__ + "static/media/Slack_evoke_small_008-ezgif.com-optimize.884b6410.gif";